<template>
 <div style="cursor:pointer;" v-on:click='$emit("clicked", {channel_id: channel_id, recording_id: recording.session} )' class="seasoncast-card">
      <div class="row scoreCardInner">

        <div class="col-7 scoreCardTeams"> 

          <div class="d-flex flex-row">
            <div style=" padding:0.5rem; ">
              <img class="scoreIMG"
                v-bind:src="'https://dvr.bunny.seasoncast.com/file/mylivegame/recordings/'+channel_id+'/'+recording.session+'/thumbnail.jpg'"
                onerror="this.onerror=null;this.src='https://app.seasoncast.com/img/live_event.png';" />
            </div>
            <div>
              <div v-if="recording.stats && recording.stats.teams.length != 0 &&  recording.stats.type == 'sport'">
              <div v-for="(team,index) in recording.stats.teams" v-bind:key="team.name" v-bind:class="(index != winner && winner != -1) ? 'scoreLost' : ''">
                    <div class="scoreCardTeamsName">
                 <span class="scoreColor" v-bind:style="'width:10px; height:10px; margin:5px; background-color:'+team.color"  >
                  &nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="" v-text="team.name"></span>
              </div>
              </div>
          
              </div>
              <div v-else>
                 <div class="scoreCardTeamsName">
                
                <span class="" v-text="recording.title.split(' vs ')[0] || recording.title"></span>
              </div>
                <div class="scoreCardTeamsName">
                
                <span class="" v-text="recording.title.split(' vs ')[1] || 'General Event'"></span>
              </div>
              </div>
            </div>



          </div>
        </div>
        <div class="col-2 scoreCardTeams">
          <div v-if="recording.stats && (totalScore != 0)">
          <div class="scoreText" v-for="(team , index) in recording.stats.teams" v-bind:key="team.name" v-text="team.score" v-bind:class="(index != winner && winner != -1) ? 'scoreLost' : ''"
            >
            </div>
        </div>


        </div>
        <div class="info col-3">
          Final<br />
          
          {{ new Date(recording.onPub).toLocaleDateString()}}
          <br />
        </div>
      </div>
    </div>       
</template>

<script>
//lose score color:#8a8a8a;

export default {
  name: 'Recording',
  props: ['recording', 'channel_id'],
   computed: {
    // a computed getter
    winner: function () {
     var winnerScore = -1
     var winnerTeam = -1
     for (let index = 0; index < this.recording.stats.teams.length; index++) {
       const element = this.recording.stats.teams[index];
       
       if (element.score > winnerScore){
         winnerScore = element.score
         winnerTeam = index
       }else if (element.score == winnerScore){
         winnerTeam = -1
       }

     }
     return winnerTeam
    },
    totalScore: function(){
      var total = 0
      if ( this.recording.stats.teams){
      for (let index = 0; index < this.recording.stats.teams.length; index++) {
        const element = this.recording.stats.teams[index];
        total += element.score
      }

    
    }
      return total
    }
   }
}
</script>

<style lang="scss" scoped>
 .info {
    border-left: 1px solid rgb(221, 221, 221);
    text-align: center;
    font-weight: 400;
    font-size: 0.8rem;

    display: flex;
    justify-content: center;
    /* align horizontal */
    align-items: center;
  }
.seasoncast-card{
    border-radius: 0.6rem;
}
  .scoreCard {
    background-color: white;

    border-radius: 0.3rem;
  }

  .scoreText {
    width: 100%;
    text-align: right;

  }

  .scoreCardTeams {
    font-size: 1.3rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

  }

  .scoreCardTeamsName {

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
  }

  .broadcastNetwork {
    text-align: center;
    color: white;
    border-radius: 0.3rem 0.3rem 0 0;
    font-size: 0.9rem;
    padding: 0.3rem
  }

  .scoreCardInner {
   
  }


  .scoreIMG {
    width: auto;
    height: 3rem;
    border-radius: 0.3rem;
    display: flex;
    justify-content: center;
    /* align horizontal */
    align-items: center;
  }

  .scoreColor {
    font-size: 0.5rem;
    line-height: 100%;
    border-radius: 0.2rem;
    display: inline-block;
    vertical-align: middle;
  }

  .scoreLost {
   color: grey;
  }

  .scoreCardHolder {
    padding: 1rem
  }

  .scoreCardTeamList {
    width: 70%;
  }

  .scoreCardListScore {
    width: 30%;
  }

  .card2 {
    border: 1px solid rgb(233, 233, 233);
    border-radius: 0.6rem;
  }

  
</style>
